// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".a4b31a097975fc3b4b885ba0bbdbd77b.js";
};